import React from "react";
import { NoFlyCreateZonePage } from "./no-fly";
import { SafeLandCreateZonePage } from "./safe-land";
import type { ZoneVariant } from "../zones-page/types";
import { VARIANT_NO_FLY, VARIANT_SAFE_LAND } from "../zones-page/types";

export type { ZoneVariant };

export interface CreateZonePageProps {
  variant?: ZoneVariant;
}

export const CreateZonePage: React.FC<CreateZonePageProps> = ({ variant = VARIANT_NO_FLY }) => {
  return variant === VARIANT_SAFE_LAND ? <SafeLandCreateZonePage /> : <NoFlyCreateZonePage />;
};